import { Injectable, Inject } from 'ng-metadata/core';
import {getVid, getBackendSystem} from '../appConfig/appConfigForward';

@Injectable()
export class SourceRecordService {
        
      constructor(
                @Inject('$http') private $http : angular.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs) {

       }

     public getSourceRecord(docId,recordOwner) {

         let url= this.restBaseURLs.sourceRecord+'?docId=' + docId +(getBackendSystem() === 'suprima' ? '&vid=' + getVid() +'&recordOwner='+recordOwner: '');
         return this.$http.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/sourceRecord/sourceRecord.service.ts